export enum ProcessReportStatus {
  AVAILABLE = "AVAILABLE",
  BUYED = "BUYED",
}
